import React, { useState } from 'react'
import { useWindowSize } from '@navent-jobs/ui-kit/hooks/window-size'
import ContentLoader from 'react-content-loader'
import { LoaderContainer, PlaceholderHeader } from './mixins'

const Component = () => {
  const { isMobile, isTabletLandscape, isTabletPortrait, isDesktop } = useWindowSize()
  const [wrapperWidth, setWrapperWidth] = useState(0)
  const wrapperSection = 0.37

  return (
    <LoaderContainer ref={node => node && setWrapperWidth(node.offsetWidth)}>
      <PlaceholderHeader isMobileOrPortrait={isMobile || isTabletPortrait}>
        {isDesktop && (
          <ContentLoader
            speed={2}
            width={wrapperWidth}
            height={80}
            viewBox={`0 0 ${wrapperWidth} 80`}
            backgroundColor="#f3f3f3"
            foregroundColor="#d4d4d4"
          >
            <rect x="24" y="12" rx="8" ry="8" width="90" height="56" />
            <rect x="130" y="18" rx="4" ry="4" width="303" height="16" />
            <rect x={wrapperWidth * 0.7716} y="30" rx="4" ry="4" width={wrapperWidth * 0.1138} height="20" />
            <rect x={wrapperWidth * 0.8945} y="30" rx="4" ry="4" width={wrapperWidth * 0.0872} height="20" />
            <rect x="130" y="46" rx="4" ry="4" width="124" height="16" />
          </ContentLoader>
        )}
        {isMobile && (
          <ContentLoader
            speed={2}
            width={wrapperWidth}
            height={132}
            viewBox={`0 0 ${wrapperWidth} 132`}
            backgroundColor="#f3f3f3"
            foregroundColor="#d4d4d4"
          >
            <rect x="16" y="84" rx="8" ry="8" width={wrapperWidth * wrapperSection} height="36" />
            <rect
              x={wrapperWidth * wrapperSection + 16 + 5}
              y="84"
              rx="8"
              ry="8"
              width={wrapperWidth * wrapperSection}
              height="36"
            />
            <rect
              x={wrapperWidth * wrapperSection * 2 + 16 + 10}
              y="84"
              rx="8"
              ry="8"
              width={wrapperWidth * 0.26 - 16 - 16 - 8}
              height="36"
            />
            <rect x="16" y="12" rx="8" ry="8" width="90" height="56" />
            <rect x="122" y="18" rx="4" ry="4" width="222" height="16" />
            <rect x="122" y="46" rx="4" ry="4" width="124" height="16" />
          </ContentLoader>
        )}
        {isTabletLandscape && (
          <ContentLoader
            speed={2}
            width={wrapperWidth}
            height={80}
            viewBox={`0 0 ${wrapperWidth} 80`}
            backgroundColor="#f3f3f3"
            foregroundColor="#d4d4d4"
          >
            <rect x="24" y="12" rx="8" ry="8" width="90" height="56" />
            <rect x="130" y="18" rx="4" ry="4" width="303" height="16" />
            <rect x={wrapperWidth * 0.6941} y="30" rx="4" ry="4" width="150" height="20" />
            <rect x={wrapperWidth * 0.8587} y="30" rx="4" ry="4" width="115" height="20" />
            <rect x="130" y="46" rx="4" ry="4" width="124" height="16" />
          </ContentLoader>
        )}
        {isTabletPortrait && (
          <ContentLoader
            speed={2}
            width={wrapperWidth}
            height={128}
            viewBox={`0 0 ${wrapperWidth} 128`}
            backgroundColor="#f3f3f3"
            foregroundColor="#d4d4d4"
          >
            <rect x="36" y="80" rx="8" ry="8" width={wrapperWidth * 0.303} height="36" />
            <rect x={wrapperWidth * 0.303 + 36 + 5} y="80" rx="8" ry="8" width={wrapperWidth * 0.303} height="36" />
            <rect
              x={wrapperWidth * 0.303 * 2 + 36 + 10}
              y="80"
              rx="8"
              ry="8"
              width={wrapperWidth * 0.303}
              height="36"
            />
            <rect x="36" y="12" rx="8" ry="8" width="90" height="56" />
            <rect x="142" y="18" rx="4" ry="4" width="222" height="16" />
            <rect x="142" y="46" rx="4" ry="4" width="124" height="16" />
          </ContentLoader>
        )}
      </PlaceholderHeader>
    </LoaderContainer>
  )
}

export default Component
